import { ModalLayout } from '../../../modal';
import { StyledMessage } from './writeup-action-model.styles';
import { UserActionModalProps } from './writeup-action-model.types';
export const CommunityWriteUpActionModal = ({
  open,
  message,
  titleText,
  openChange,
  headingIcon,
  isHeadingIcon,
  actionButtonText,
  handleModalAction,
  actionButtonColor = 'primary'
}: UserActionModalProps) => <ModalLayout open={open} showWarnBox={false} openChange={openChange} closeButtonText="Cancel" headingIcon={headingIcon} showTriggerElement={false} modalTitleText={titleText} isHeadingIcon={isHeadingIcon} actionButtonText={actionButtonText} actionButtonColor={actionButtonColor} handleActionButton={handleModalAction} data-sentry-element="ModalLayout" data-sentry-component="CommunityWriteUpActionModal" data-sentry-source-file="writeup-action-model.tsx">
    <StyledMessage data-sentry-element="StyledMessage" data-sentry-source-file="writeup-action-model.tsx">{message}</StyledMessage>
  </ModalLayout>;